<div class="p-inputgroup">
  <ngx-intl-tel-input #phone="ngModel" name="phone" id="phone"
                      [cssClass]="'custom'" [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
                      [enablePlaceholder]="true" [searchCountryFlag]="true" [searchCountryField]="[SearchCountryField.Iso2,SearchCountryField.Name]"
                      [selectFirstCountry]="true" [maxLength]="MaxPhoneNumberLength" [phoneValidation]="true"
                      [separateDialCode]="false" [numberFormat]="PhoneNumberFormat.National"
                      [ngModel]="nationalNumber" (ngModelChange)="writeValue($event)"
                      [disabled]="isDisabled">
  </ngx-intl-tel-input>
  <button pButton pRipple type="button" icon="pi pi-times" styleClass="p-button-success phone-clear"
          (click)="onClickClearPhoneNumber()" style="position:relative!important;left:-30px!important;"></button>
  <button *ngIf="phone?.control?.errors && !phone?.control?.pristine"
          pButton pRipple type="button" class="icon-negative" icon="fa fa-exclamation-triangle" pTooltip="Enter valid phone number"
          style="position:relative!important;left:-10px!important;"></button>
</div>
